import {SaveParamsClientService} from '../services'

export default ( params) => {
    return new Promise((resolve) => {
        SaveParamsClientService.update( params)
            .then(response =>{
                resolve({ success: true, data: response.data })
            })
    })
}